/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "chat/models.proto" (package "rd.chat", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { User } from "../user/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * Message represents an internal or external communication message. Messages
 * can exist completely within Rundoo or be sent external via email, text, or
 * phone. Messages are attached to Threads.
 *
 * @generated from protobuf message rd.chat.Message
 */
export interface Message {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 3
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.chat.Message.Type type = 6
     */
    type: Message_Type;
    /**
     * @generated from protobuf field: rd.user.User sent_by = 7
     */
    sentBy?: User; // outbound
    /**
     * @generated from protobuf field: rd.user.User received_by = 8
     */
    receivedBy?: User; // inbound
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sent_at = 9
     */
    sentAt?: Timestamp;
    /**
     * @generated from protobuf field: string text = 10
     */
    text: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID thread_id = 11
     */
    threadId?: UUID;
    /**
     * @generated from protobuf field: rd.chat.Message.Email email = 12
     */
    email?: Message_Email;
    /**
     * @generated from protobuf field: rd.chat.Message.Phone phone = 13
     */
    phone?: Message_Phone;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID attachment_ids = 14
     */
    attachmentIds: UUID[];
}
/**
 * @generated from protobuf message rd.chat.Message.Email
 */
export interface Message_Email {
    /**
     * @generated from protobuf field: rd.chat.Message.Email.Provider provider = 1
     */
    provider: Message_Email_Provider;
}
/**
 * @generated from protobuf enum rd.chat.Message.Email.Provider
 */
export enum Message_Email_Provider {
    /**
     * @generated from protobuf enum value: PROVIDER_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: PROVIDER_GMAIL = 1;
     */
    GMAIL = 1,
    /**
     * @generated from protobuf enum value: PROVIDER_OUTLOOK = 2;
     */
    OUTLOOK = 2
}
/**
 * @generated from protobuf message rd.chat.Message.Phone
 */
export interface Message_Phone {
    /**
     * @generated from protobuf field: string to_phone_number = 1
     */
    toPhoneNumber: string;
    /**
     * @generated from protobuf field: string from_phone_number = 2
     */
    fromPhoneNumber: string;
}
/**
 * @generated from protobuf enum rd.chat.Message.Type
 */
export enum Message_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * replaces rd.customer.Interaction
     *
     * @generated from protobuf enum value: TYPE_INTERNAL_NOTE = 1;
     */
    INTERNAL_NOTE = 1,
    /**
     * @generated from protobuf enum value: TYPE_EXTERNAL_OUTBOUND_EMAIL = 2;
     */
    EXTERNAL_OUTBOUND_EMAIL = 2,
    /**
     * @generated from protobuf enum value: TYPE_EXTERNAL_INBOUND_EMAIL = 3;
     */
    EXTERNAL_INBOUND_EMAIL = 3,
    /**
     * @generated from protobuf enum value: TYPE_EXTERNAL_OUTBOUND_SMS = 4;
     */
    EXTERNAL_OUTBOUND_SMS = 4,
    /**
     * @generated from protobuf enum value: TYPE_EXTERNAL_INBOUND_SMS = 5;
     */
    EXTERNAL_INBOUND_SMS = 5
}
/**
 * Thread represents a conversation and stores conversation metadata. A
 * conversation comprises Messages that share the same thread id.
 *
 * @generated from protobuf message rd.chat.Thread
 */
export interface Thread {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 3
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_activity_at = 6
     */
    lastActivityAt?: Timestamp; // updated when a message is added/edited
    /**
     * @generated from protobuf field: rd.chat.Thread.AttachedTo attached_to = 7
     */
    attachedTo: Thread_AttachedTo;
    /**
     * @generated from protobuf field: string attached_to_id = 8
     */
    attachedToId: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 9
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string customer_contact_id_string = 10
     */
    customerContactIdString: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_read_at = 11
     */
    lastReadAt?: Timestamp;
}
/**
 * this will let us easily extend to generic internal message threads
 * attached to various objects
 *
 * @generated from protobuf enum rd.chat.Thread.AttachedTo
 */
export enum Thread_AttachedTo {
    /**
     * @generated from protobuf enum value: ATTACHED_TO_NONE = 0;
     */
    NONE = 0,
    /**
     * replaces customer interaction
     *
     * @generated from protobuf enum value: ATTACHED_TO_CUSTOMER = 1;
     */
    CUSTOMER = 1,
    /**
     * @generated from protobuf enum value: ATTACHED_TO_PRODUCT = 2;
     */
    PRODUCT = 2,
    /**
     * @generated from protobuf enum value: ATTACHED_TO_SALE = 3;
     */
    SALE = 3,
    /**
     * @generated from protobuf enum value: ATTACHED_TO_ORDER = 4;
     */
    ORDER = 4,
    /**
     * phone no. without a corresponding contact
     *
     * @generated from protobuf enum value: ATTACHED_TO_CUSTOMER_PHONE = 5;
     */
    CUSTOMER_PHONE = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class Message$Type extends MessageType<Message> {
    constructor() {
        super("rd.chat.Message", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "location_id", kind: "message", T: () => UUID },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "type", kind: "enum", T: () => ["rd.chat.Message.Type", Message_Type, "TYPE_"] },
            { no: 7, name: "sent_by", kind: "message", T: () => User },
            { no: 8, name: "received_by", kind: "message", T: () => User },
            { no: 9, name: "sent_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "thread_id", kind: "message", T: () => UUID },
            { no: 12, name: "email", kind: "message", T: () => Message_Email },
            { no: 13, name: "phone", kind: "message", T: () => Message_Phone },
            { no: 14, name: "attachment_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Message>): Message {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.text = "";
        message.attachmentIds = [];
        if (value !== undefined)
            reflectionMergePartial<Message>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message): Message {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 3:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.chat.Message.Type type */ 6:
                    message.type = reader.int32();
                    break;
                case /* rd.user.User sent_by */ 7:
                    message.sentBy = User.internalBinaryRead(reader, reader.uint32(), options, message.sentBy);
                    break;
                case /* rd.user.User received_by */ 8:
                    message.receivedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.receivedBy);
                    break;
                case /* google.protobuf.Timestamp sent_at */ 9:
                    message.sentAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.sentAt);
                    break;
                case /* string text */ 10:
                    message.text = reader.string();
                    break;
                case /* rd.proto.uuid.UUID thread_id */ 11:
                    message.threadId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.threadId);
                    break;
                case /* rd.chat.Message.Email email */ 12:
                    message.email = Message_Email.internalBinaryRead(reader, reader.uint32(), options, message.email);
                    break;
                case /* rd.chat.Message.Phone phone */ 13:
                    message.phone = Message_Phone.internalBinaryRead(reader, reader.uint32(), options, message.phone);
                    break;
                case /* repeated rd.proto.uuid.UUID attachment_ids */ 14:
                    message.attachmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 3; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.chat.Message.Type type = 6; */
        if (message.type !== 0)
            writer.tag(6, WireType.Varint).int32(message.type);
        /* rd.user.User sent_by = 7; */
        if (message.sentBy)
            User.internalBinaryWrite(message.sentBy, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User received_by = 8; */
        if (message.receivedBy)
            User.internalBinaryWrite(message.receivedBy, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sent_at = 9; */
        if (message.sentAt)
            Timestamp.internalBinaryWrite(message.sentAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string text = 10; */
        if (message.text !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.text);
        /* rd.proto.uuid.UUID thread_id = 11; */
        if (message.threadId)
            UUID.internalBinaryWrite(message.threadId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.chat.Message.Email email = 12; */
        if (message.email)
            Message_Email.internalBinaryWrite(message.email, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.chat.Message.Phone phone = 13; */
        if (message.phone)
            Message_Phone.internalBinaryWrite(message.phone, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID attachment_ids = 14; */
        for (let i = 0; i < message.attachmentIds.length; i++)
            UUID.internalBinaryWrite(message.attachmentIds[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.chat.Message
 */
export const Message = new Message$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Email$Type extends MessageType<Message_Email> {
    constructor() {
        super("rd.chat.Message.Email", [
            { no: 1, name: "provider", kind: "enum", T: () => ["rd.chat.Message.Email.Provider", Message_Email_Provider, "PROVIDER_"] }
        ]);
    }
    create(value?: PartialMessage<Message_Email>): Message_Email {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.provider = 0;
        if (value !== undefined)
            reflectionMergePartial<Message_Email>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Email): Message_Email {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.chat.Message.Email.Provider provider */ 1:
                    message.provider = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Email, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.chat.Message.Email.Provider provider = 1; */
        if (message.provider !== 0)
            writer.tag(1, WireType.Varint).int32(message.provider);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.chat.Message.Email
 */
export const Message_Email = new Message_Email$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message_Phone$Type extends MessageType<Message_Phone> {
    constructor() {
        super("rd.chat.Message.Phone", [
            { no: 1, name: "to_phone_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "from_phone_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Message_Phone>): Message_Phone {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toPhoneNumber = "";
        message.fromPhoneNumber = "";
        if (value !== undefined)
            reflectionMergePartial<Message_Phone>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message_Phone): Message_Phone {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string to_phone_number */ 1:
                    message.toPhoneNumber = reader.string();
                    break;
                case /* string from_phone_number */ 2:
                    message.fromPhoneNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Message_Phone, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string to_phone_number = 1; */
        if (message.toPhoneNumber !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toPhoneNumber);
        /* string from_phone_number = 2; */
        if (message.fromPhoneNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fromPhoneNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.chat.Message.Phone
 */
export const Message_Phone = new Message_Phone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Thread$Type extends MessageType<Thread> {
    constructor() {
        super("rd.chat.Thread", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "location_id", kind: "message", T: () => UUID },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "last_activity_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "attached_to", kind: "enum", T: () => ["rd.chat.Thread.AttachedTo", Thread_AttachedTo, "ATTACHED_TO_"] },
            { no: 8, name: "attached_to_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "customer_id", kind: "message", T: () => UUID },
            { no: 10, name: "customer_contact_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "last_read_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<Thread>): Thread {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.attachedTo = 0;
        message.attachedToId = "";
        message.customerContactIdString = "";
        if (value !== undefined)
            reflectionMergePartial<Thread>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Thread): Thread {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 3:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp last_activity_at */ 6:
                    message.lastActivityAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastActivityAt);
                    break;
                case /* rd.chat.Thread.AttachedTo attached_to */ 7:
                    message.attachedTo = reader.int32();
                    break;
                case /* string attached_to_id */ 8:
                    message.attachedToId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 9:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string customer_contact_id_string */ 10:
                    message.customerContactIdString = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_read_at */ 11:
                    message.lastReadAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastReadAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Thread, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 3; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_activity_at = 6; */
        if (message.lastActivityAt)
            Timestamp.internalBinaryWrite(message.lastActivityAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.chat.Thread.AttachedTo attached_to = 7; */
        if (message.attachedTo !== 0)
            writer.tag(7, WireType.Varint).int32(message.attachedTo);
        /* string attached_to_id = 8; */
        if (message.attachedToId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.attachedToId);
        /* rd.proto.uuid.UUID customer_id = 9; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string customer_contact_id_string = 10; */
        if (message.customerContactIdString !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.customerContactIdString);
        /* google.protobuf.Timestamp last_read_at = 11; */
        if (message.lastReadAt)
            Timestamp.internalBinaryWrite(message.lastReadAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.chat.Thread
 */
export const Thread = new Thread$Type();
